import {SwitchAccountWrapper,SwitchAccountTitle,SwitchAccountIcon} from "../../container/accountSettings.styles";

import Line from "../../../../assets/icon/line.svg"

const SwitchAccount = () => {
    return(
        <SwitchAccountWrapper>
            <SwitchAccountTitle> Swtich Account </SwitchAccountTitle>
            <SwitchAccountIcon src={Line} alt="image"/>

        </SwitchAccountWrapper>
    )
}
export default SwitchAccount;